'use strict';
module.exports = function (min, max) {
	if (max === undefined) {
		max = min;
		min = 0;
	}

	if (typeof min !== 'number' || typeof max !== 'number') {
		throw new TypeError('Expected all arguments to be numbers');
	}

	return Math.floor(Math.random() * (max - min + 1) + min);
};



//////////////////
// WEBPACK FOOTER
// ./~/random-int/index.js
// module id = 49
// module chunks = 23899280101116 35783957827783 188034299440437